import getConfig from 'next/config'
import { getLineOfBusiness } from 'src/siteBuilder/lineOfBusiness/lineOfBusiness'

const {
  publicRuntimeConfig: { API_BASE_PATH },
} = getConfig()

export const isBusinessPage = (asPath: string): boolean => getLineOfBusiness(asPath).pageBrand === 'corporate'

export interface GetOffersParams {
  mobilityProductId: string
  accountType: string
  accountSubtype: string
  province: string
}

export const getOffers = async ({ mobilityProductId, accountType, accountSubtype, province }: GetOffersParams) => {
  const response = await fetch(`${API_BASE_PATH}api/mobilityOffers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mobilityProductId, accountType, accountSubtype, province }),
  })

  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.error ?? `Failed to fetch offers: ${response.status}`)
  }

  return response.json()
}
